export default {
  primary: "#1AE06E",
  secondary: "#1356A1",
  accent: "#82B1FF",
};
